import { AlexStateProvider } from './state.tsx';
import { AssistantProvider } from './AssistantProvider.tsx';
import { AssistantPane } from './AssistantPane.tsx';

/** `embedded`: true only in the host's desktop side panel (data-layout="embed"), which enables the header close (X) that dispatches the panel-close event. */
export function AlexTab({ embedded = false }: { embedded?: boolean }) {
	return (
		<AlexStateProvider>
			<AssistantProvider>
				<AssistantPane embedded={embedded} />
			</AssistantProvider>
		</AlexStateProvider>
	);
}
